import { getCustomerServiceList, getSceneGroup } from '@/api/scene';

const urlScheme = 'dingtalk://dingtalkclient';
const cropId = 'ding3c8c9c015147fde94210d8170298fd9d';

const openDingTalk = (href: string) => {
  const a = document.createElement('a');
  a.href = href;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const useDingTalk = () => {
  const handleGroupChat = async (sceneId: string) => {
    if (sceneId) {
      const { code, data } = await getSceneGroup({ sceneId });
      if (code === 200 && data?.chatId) {
        openDingTalk(
          `${urlScheme}/page/conversation?cropId=${cropId}&chatId=${data.chatId}`,
        );
      }
    }
  };

  const handleContact = (userInfo: any) => {
    if (userInfo) {
      openDingTalk(
        `${urlScheme}/page/profile?phone=${userInfo.phonenumberReal || userInfo.phonenumber}`,
      );
    }
  };

  const handleCustomService = async () => {
    const { code, data } = await getCustomerServiceList();
    if (code === 200) {
      handleContact(data?.[0]);
    }
  };

  return {
    handleGroupChat,
    handleContact,
    handleCustomService,
  };
};
